import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { API_URL } from "../../shared/constant";
import Loader from "../../shared/loader";
import axios from "axios";
import Swal from "sweetalert2";
import Select from "react-select";

const Category = () => {
  const [categoryData, setCategoryData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [dealerId, setDealerId] = useState(null);
  const [dealerData, setDealerData] = useState([]);

  const getCategory = () => {
    setLoading(true);
    axios.post(API_URL.CATEGORY_LIST, { dealer_id: dealerId }).then(
      (res) => {
        if (res.data.status === 1) {
          setCategoryData(res.data.data);
        }
        setLoading(false);
      }
    );
  };

  const getDealer = () => {
    setLoading(true);
    axios.post(API_URL.USERS_DEALERS, {}).then(
      (res) => {
        if (res.data.status === 1) {
          let cd = res.data.data.map((caw) => {
            return {
              label: caw.name + " - " + caw.contact_no,
              value: caw.id,
            };
          });
          setDealerData(cd);
        }
        setLoading(false);
      }
    );
  };

  const updateCategorySequence = (id, sequence) => {
    axios.post(API_URL.CATEGORY_SEQUENCE, { id: id, sequence: sequence}).then(
      (res) => {
        if (res.data.status === 1) {
          setCategoryData(categoryData.map((r) => r.id == id ? { ...r, sequence: sequence } : r));
          toast.success("Category Sequence Updated Successfully", { autoClose: 3000 });
        } else {
          toast.error(res.data.data, { autoClose: 3000 });
        }
      },
      (error) => {
        console.log(error.response.data)
        toast.error(error.response.data.message, {
          autoClose: 3000,
        });
      }
    );
  };

  const updateCategoryStatus = (id, status, name) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to " + (status == 1 ? "show" : "hide") + " this - " + name,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, " + (status == 1 ? "show" : "hide") + " it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        axios.post(API_URL.CATEGORY_UPDATE_STATUS, { id: id, active: status }).then(
          (res) => {
            if (res.data.status === 1) {
              let newData = categoryData.map((r) => r.id == id ? { ...r, active: status } : r);
              setCategoryData(newData);
              toast.success("Status Updated Successfully", { autoClose: 3000 });
            } else {
                toast.error(res.data.data, { autoClose: 3000 });
            }
            setLoading(false);
          },
          (error) => {
            setLoading(false);
            toast.error("Something went wrong..", { autoClose: 3000 });
          }
        );
      }
    });
  };

  const deleteCategory = (row) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this Category",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        axios.post(API_URL.CATEGORY_DELETE, { id: row.id }).then(
          (res) => {
            if (res.data.status === 1) {
              let newData = categoryData.filter((r) => r.id != row.id);
              setCategoryData(newData);
              toast.success(row.name + " Delete Successfully", { autoClose: 3000 });
            } else {
              toast.error(res.data.data, { autoClose: 3000 });
            }
            setLoading(false);
          },
          (error) => {
            setLoading(false);
            toast.error("Something went wrong..", { autoClose: 3000 });
          }
        );
      }
    });
  };

  useEffect(() => {
    getCategory();
  }, [dealerId]);

  useEffect(() => {
    getDealer();
  }, []);

  return (
    <>
      <div className="row">
        <div className="col-6">
          <h1>
            Category <small className="me-2">({categoryData.length})</small>
          </h1>
        </div>
        <div className="col-6">
          <div className="d-flex align-items-center  justify-content-end">
            <div className="form-group mb-0 mr-2" style={{ width: 300 }}>
              <Select
                options={dealerData}
                value={dealerData.find((r) => r.id == dealerId)}
                onChange={(e) => setDealerId(e.value)}
                placeholder="Select Dealer"
              />
            </div>
            <Link to={"/category/add"} className="btn btn-primary">
              <i className="fa fa-plus-circle me-2" aria-hidden="true"></i> Add
              Category
            </Link>
          </div>
        </div>
        <div className="col-sm-12">
          <div className="card">
            <div className="card-body p-0">
              {loading && <Loader></Loader>}
              {!loading && (
                <div className="table-responsive">
                  <table className="table">
                    <thead className="">
                      <tr>
                        <th>#</th>
                        <th style={{ width: "150px" }}>Image</th>
                        <th>Name</th>
                                                <th width="100px">Position</th>

                        <th className="text-center" style={{ width: "200px" }}>
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {categoryData.map((row, key) => {
                        return (
                          <tr key={key}>
                            <td style={{ width: "30px" }}>{key + 1}</td>
                            <td>
                              <div
                                style={{
                                  height: "50px",
                                  maxWidth: "50px",
                                  backgroundSize: 'contain',
                                  backgroundImage: "url(" + row.image + ")",
                                }}
                              ></div>
                            </td>
                            <td>{row.name}</td>
                             <td>
                              <input type="number" value={row.sequence} onChange={(e) => updateCategorySequence(row.id, e.target.value)} className="form-control" />
                            </td>
                            <td
                              className="d-flex justify-content-center gap-2"
                              style={{ width: "200px" }}
                            >
                              <Link
                                to={"/category/edit/" + row.id}
                                className="btn btn-sm btn-secondary mr-2"
                              >
                                <i className="fa fa-edit me-1"></i> Edit
                              </Link>
                              { row.active == 1 && <button
                                onClick={() => updateCategoryStatus(row.id, 0, row.name)}
                                className="btn btn-sm btn-warning mr-2"
                              >
                                <i className="fa fa-eye-slash me-1"></i> Hide
                              </button>
                              }
                              { row.active == 0 && <button
                                onClick={() => updateCategoryStatus(row.id, 1, row.name)}
                                className="btn btn-sm btn-success mr-2"
                              >
                                <i className="fa fa-eye me-1"></i> Show
                              </button>
                              }
                              <button
                                onClick={() => deleteCategory(row)}
                                className="btn btn-sm btn-danger"
                              >
                                <i className="fa fa-trash me-1"></i> Delete
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Category;
